<app-dialog [interceptClose]="true" (closeRequested)="requestClose()">
  <app-dialog-title>{{
    'SHARED.ASK_FREQUENCY.OVERRIDE_DIALOG.TITLE' | translate: { unit: data.unitName }
  }}</app-dialog-title>

  <app-dialog-content>
    <form class="override-dialog" [formGroup]="form" (ngSubmit)="save()">
      <p class="override-dialog__intro">
        @if (data.itemName) {
          {{
            'SHARED.ASK_FREQUENCY.OVERRIDE_DIALOG.INTRO_ITEM'
              | translate: { item: data.itemName, unit: unitParams.unit }
          }}
        } @else {
          {{ introKey | translate: unitParams }}
        }
      </p>
      <mat-radio-group
        class="override-dialog__choices"
        formControlName="mode"
        [attr.aria-label]="
          'SHARED.ASK_FREQUENCY.OVERRIDE_DIALOG.TITLE' | translate: { unit: data.unitName }
        ">
        <mat-radio-button value="follow" data-testid="radio-ask-frequency-follow-account">
          <span class="override-dialog__choice">
            <span class="override-dialog__choice-label">{{
              'SHARED.ASK_FREQUENCY.OVERRIDE_DIALOG.FOLLOW_ACCOUNT' | translate
            }}</span>
            <span class="override-dialog__choice-help">{{
              'SHARED.ASK_FREQUENCY.OVERRIDE_DIALOG.FOLLOW_ACCOUNT_HELP'
                | translate: { frequency: accountFrequencyText }
            }}</span>
          </span>
        </mat-radio-button>
        <mat-radio-button value="override" data-testid="radio-ask-frequency-override">
          <span class="override-dialog__choice">
            <span class="override-dialog__choice-label" id="ask-frequency-override-choice">{{
              'SHARED.ASK_FREQUENCY.OVERRIDE_DIALOG.OVERRIDE' | translate
            }}</span>
            <span class="override-dialog__choice-help">{{
              'SHARED.ASK_FREQUENCY.OVERRIDE_DIALOG.OVERRIDE_HELP' | translate: unitParams
            }}</span>
          </span>
        </mat-radio-button>
        @if (isOverride()) {
          <div
            class="override-dialog__frequency"
            role="group"
            aria-labelledby="ask-frequency-override-choice">
            <app-ask-frequency-field [group]="form.controls.frequency" [showCounting]="false" />
            @if (isCounted()) {
              <p class="override-dialog__counting">{{ countingKey | translate: unitParams }}</p>
            }
          </div>
        }
      </mat-radio-group>
    </form>
  </app-dialog-content>

  <app-dialog-actions>
    <button
      matButton
      type="button"
      data-testid="btn-ask-frequency-override-cancel"
      [disabled]="isSaving()"
      (click)="requestClose()">
      {{ 'SHARED.SYSTEM.CANCEL' | translate }}
    </button>
    <button
      matButton="filled"
      type="button"
      data-testid="btn-ask-frequency-override-save"
      [disabled]="isSaving()"
      (click)="save()">
      {{ 'SHARED.SYSTEM.SAVE' | translate }}
    </button>
  </app-dialog-actions>
</app-dialog>
